import {i18n} from 'src/boot/i18n';
import ambitusRoutes from '../modules/ambitus/router';
import { authenticationService } from 'src/modules/user/authentication/AuthenticationService';

const routes = [
  {
    path: '/',
    component: () => import('src/modules/global/layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        redirect: '/home',
      },
    ],
  },
  {
    path: '/home',
    component: () => import('src/modules/global/layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/catalog/HomePage.vue'),
        name: 'Home',
        meta: {
          title: i18n.t('routes.home'),
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/catalog',
    component: () => import('src/modules/global/layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/catalog/CatalogPage.vue'),
        name: 'Catalog',
        meta: {
          title: i18n.t('routes.catalog'),
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/catalog/import',
    component: () => import('src/modules/global/layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/catalog/ImportMusicxmlPiecePage.vue'),
        name: 'ImportMusicxmlPiece',
        meta: {
          title: i18n.t('routes.catalogImport'),
          requiresAuth: true,
          isPremium: true
        },
      },
    ],
  },
  {
    path: '/challenges',
    component: () => import('src/modules/global/layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/catalog/ChallengesPage.vue'),
        name: 'Challenge',
        meta: {
          title: i18n.t('routes.challenges'),
          requiresAuth: true,
        },
      },
    ],
  },

  {
    path: '/profile',
    component: () => import('src/modules/global/layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('../modules/user/profile/pages/ProfilePage.vue'),
        name: 'Profile',
        meta: {
          title: i18n.t('routes.profile'),
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/onboarding-recap',
    component: () => import('src/modules/global/layouts/MainLayoutWithoutMobileNavbar.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/onboarding/checklist/OnboardingChecklistPage.vue'),
        name: 'OnboardingRecap',
        meta: {
          title: i18n.t('routes.onboarding'),
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/ambitus',
    component: () => import('src/modules/global/layouts/MainLayoutWithoutMobileNavbar.vue'),
    children: ambitusRoutes,
  },
  {
    path: '/subscribe',
    component: () => import('src/modules/global/layouts/EmptyLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('../modules/user/subscription/SubscribePage.vue'),
        name: 'Subscribe Page',
        meta: {
          title: i18n.t('routes.subscribe'),
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/early-access',
    component: () => import('src/modules/global/layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('../modules/user/subscription/EarlyAccessPage.vue'),
        name: 'EarlyAccess',
        meta: {
          title: i18n.t('routes.subscribe'),
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/subscribe/success',
    component: () => import('src/modules/global/layouts/EmptyLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('../modules/user/subscription/SubscribeSuccessPage.vue'),
        name: 'SubscribeSuccessPage',
        meta: {
          title: i18n.t('routes.subscribeSuccess'),
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/list',
    component: () => import('src/modules/global/layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/catalog/UserCatalogPage.vue'),
        name: 'UserCatalogPage',
        meta: {
          title: i18n.t('routes.userCatalog'),
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/revisions',
    component: () => import('src/modules/global/layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/catalog/UserRevisionPage.vue'),
        name: 'UserRevisionPage',
        meta: {
          title: i18n.t('routes.userRevision'),
          requiresAuth: true,
        },
      },
    ],
  },

  {
    path: '/song/:playableType/:playableId/:artist/:songname',
    component: () => import('src/modules/global/layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/playable/pages/SongPage/SongPage.vue'),
        name: 'Song',
        meta: {
          title: (route) => `${route.params.artist} - ${route.params.songname}`,
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/song/:playableType/:playableId/:artist/:songname/partition',
    component: () => import('src/modules/global/layouts/EmptyLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/playable/pages/SongPage/DownloadPartitionPage.vue'),
        name: 'download-partition',
        meta: {
          title: (route) => `${route.params.artist} - ${route.params.songname}`,
          requiresAuth: true,
          isPremium: true,
        },
      },
    ],
  },
  {
    path: '/player/school/:playableType/:playableId',
    component: () => import('src/modules/global/layouts/MainLayoutWithoutMobileNavbar.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/player/PlayerPage.vue'),
        name: 'Player School',
        meta: {
          title: i18n.t('routes.exercise'),
          requiresAuth: true,
          isPremium: true,
        },
      },
    ],
  },
  {
    path: '/player/challenge/:playableId/:artist/:songname',
    component: () => import('src/modules/global/layouts/MainLayoutWithoutMobileNavbar.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/player/PlayerPage.vue'),
        name: 'Player Challenge',
        meta: {
          title: (route) => `${i18n.t('routes.reading')} - ${route.params.artist} - ${route.params.songname}`,
          requiresAuth: true,
          isPremium: true,
        },
      },
    ],
  },
  {
    path: '/player/version/:playableId/:artist/:songname',
    component: () => import('src/modules/global/layouts/MainLayoutWithoutMobileNavbar.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/player/PlayerPage.vue'),
        name: 'Player',
        meta: {
          title: (route) => `${i18n.t('routes.reading')} - ${route.params.artist} - ${route.params.songname}`,
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/player/evaluation',
    component: () => import('src/modules/global/layouts/MainLayoutWithoutMobileNavbar.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/player/PlayerPage.vue'),
        name: 'Player Evaluation',
        meta: {
          title: i18n.t('routes.evaluation'),
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/learn/:playableType/:playableId/:artist/:songname',
    component: () => import('src/modules/global/layouts/MainLayoutWithoutMobileNavbar.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/player/PlayerPage.vue'),
        name: 'Player Class',
        meta: {
          title: (route) => `${i18n.t('routes.course')} - ${route.params.artist} - ${route.params.songname} - Etape ${route.params.step} `,
          requiresAuth: true,
          isPremium: true,
        },
      },
    ],
  },

  /* School Pages */
  {
    path: '/school/modules',
    component: () => import('src/modules/global/layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/school/SchoolModulesPage.vue'),
        name: 'Liste des leçons',
        meta: {
          title: i18n.t('routes.lessons'),
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/school/module/:moduleId',
    component: () => import('src/modules/global/layouts/MainLayoutWithoutMobileNavbar.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/school/SchoolModulePage.vue'),
        name: 'Leçon',
        meta: {
          title: i18n.t('routes.lesson'),
          requiresAuth: true,
          isPremium: true,
        },
      },
    ],
  },

  {
    path: '/school/skill-categories/:categoryId',
    component: () => import('src/modules/global/layouts/MainLayoutWithoutMobileNavbar.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/school/pages/SkillListPage.vue'),
        name: 'Liste des compétences',
        meta: {
          title: i18n.t('routes.skills'),
          requiresAuth: true
        },
      },
    ],
  },
  {
    path: '/school/skill-categories/:categoryId/skills/:skillId',
    component: () => import('src/modules/global/layouts/MainLayoutWithoutMobileNavbar.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/school/pages/SkillDetailPage.vue'),
        name: 'Compétence',
        meta: {
          title: i18n.t('routes.skill'),
          requiresAuth: true
        },
      },
    ],
  },
  {
    path: '/school/video-categories/:categoryId',
    component: () => import('src/modules/global/layouts/MainLayoutWithoutMobileNavbar.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/school/pages/VideoListPage.vue'),
        name: 'video-list',
        meta: {
          title: i18n.t('routes.videos'),
          requiresAuth: true
        },
      },
    ],
  },

  /* Admin Pages */

  {
    path: '/lyrics-editor/:playableType/:playableId/:artist/:songname',
    component: () => import('src/modules/global/layouts/MainLayoutWithoutMobileNavbar.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/admin/LyricsEditor.vue'),
        name: 'LyricsEditor',
        meta: {
          title: () => i18n.t('routes.lyricsEditor'),
          requiresAuth: true,
        },
      },
    ],
  },
    {
    path: '/handprints-admin',
    component: () => import('src/modules/global/layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/admin/DisplayHandprint.vue'),
        name: 'Handprints Admin',
        meta: {
          title: i18n.t('routes.handprintsAdmin'),
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/rythmics-admin',
    component: () => import('src/modules/global/layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        redirect: '/rhythmics-admin',
      },
    ],
  },
  {
    path: '/rhythmics-admin',
    component: () => import('src/modules/global/layouts/MainLayoutWithoutMobileNavbar.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/admin/RhythmicsPanel.vue'),
        name: 'Rythmiques Admin',
        meta: {
          title: i18n.t('routes.rhythmicsAdmin'),
          requiresAuth: true,
        },
      },
    ],
  },

  {
    path: '/pitchertest',
    component: () => import('src/modules/global/layouts/MainLayoutWithoutMobileNavbar.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/admin/PitcherTest.vue'),
        name: 'Pitcher',
        meta: {
          title: (route) => `${i18n.t('routes.tests')} - ${route.params.artist} - ${route.params.songname}`,
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/synth_test',
    component: () => import('src/modules/global/layouts/MainLayoutWithoutMobileNavbar.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/admin/SynthTest.vue'),
        name: 'SynthTest',
        meta: {
          title: (route) => `${i18n.t('routes.synthTest')} - ${route.params.artist} - ${route.params.songname}`,
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/test-notification',
    component: () => import('src/modules/global/layouts/MainLayoutWithoutMobileNavbar.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/admin/TestNotifications.vue'),
        name: 'Test Notification',
        meta: {
          title: i18n.t('routes.testNotification'),
          requiresAuth: true,
        },
      },
    ],
  },

  /* Outside the App */
  // Utility pages like login
  // Use Empty Layout

  {
    path: '/login',
    component: () => import('src/modules/global/layouts/EmptyLayout'),
    children: [
      {
        path: '',
        component: () => import('../modules/user/authentication/pages/LoginPage.vue'),
        name: 'Login',
        meta: {
          title: i18n.t('routes.login'),
        },
      },
    ],
  },
  {
    path: '/logout',
    beforeEnter() {
      authenticationService.logout();
    },
  },
  {
    path: '/signup',
    component: () => import('src/modules/global/layouts/EmptyLayout'),
    children: [
      {
        path: '',
        component: () => import('../modules/user/authentication/pages/LoginPage.vue'),
        name: 'Signup',
        meta: {
          title: i18n.t('routes.signup'),
        },
      },
    ],
  },

  {
    path: '/forgot-password',
    component: () => import('src/modules/global/layouts/EmptyLayout'),
    children: [
      {
        path: '',
        component: () => import('../modules/user/authentication/pages/ForgotPasswordPage.vue'),
        name: 'ForgotPassword',
        meta: {
          title: i18n.t('routes.forgotPassword'),
        },
      },
    ],
  },
  {
    path: '/forgot-password/:email',
    component: () => import('src/modules/global/layouts/EmptyLayout'),
    children: [
      {
        path: '',
        component: () => import('../modules/user/authentication/pages/ForgotPasswordPage.vue'),
        name: 'ForgotPasswordMail',
        meta: {
          title: i18n.t('routes.forgotPassword'),
        },
      },
    ],
  },
  {
    path: '/change-password/:token',
    component: () => import('src/modules/global/layouts/EmptyLayout'),
    children: [
      {
        path: '',
        component: () => import('../modules/user/authentication/pages/ChangePasswordPage.vue'),
        name: 'ChangePassword',
        meta: {
          title: i18n.t('routes.changePassword'),
        },
      },
    ],
  },

  {
    path: '/maintenance',
    component: () => import('src/modules/global/layouts/EmptyLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/global/MaintenancePage.vue'),
        name: 'Maintenance',
        meta: {
          title: i18n.t('routes.maintenance'),
          requiresAuth: false,
        },
      },
    ],
  },
  {
    path: '/update',
    component: () => import('src/modules/global/layouts/EmptyLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/global/UpdatePage.vue'),
        name: 'Update',
        meta: {
          title: i18n.t('routes.update'),
          requiresAuth: false,
        },
      },
    ],
  },
  {
    path: '/update-error',
    component: () => import('src/modules/global/layouts/EmptyLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/global/ErrorUpdatePage.vue'),
        name: 'Update Error',
        meta: {
          title: i18n.t('routes.updateError'),
          requiresAuth: false,
        },
      },
    ],
  },
  {
    path: '/store',
    component: () => import('src/modules/global/layouts/EmptyLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/global/StoreMobilePage.vue'),
        name: 'StoreMobilePage',
        meta: {
          title: i18n.t('routes.store'),
        },
      },
    ],
  },
  {
    path: '/account-deleted',
    component: () => import('src/modules/global/layouts/EmptyLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/user/profile/pages/AccountDeleted.vue'),
        name: 'account-deleted',
        meta: {
          title: i18n.t('routes.accountDeleted'),
          requiresAuth: false,
        },
      },
    ],
  },
  {
    path: '/offline',
    component: () => import('src/modules/global/layouts/EmptyLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/global/OfflinePage.vue'),
        name: 'Offline',
        meta: {
          title: i18n.t('routes.offline'),
          requiresAuth: false,
        },
      },
    ],
  },
  {
    path: '/auth',
    component: () => import('src/modules/global/layouts/EmptyLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/user/authentication/pages/Authentication.vue'),
        name: 'Authentication',
        meta: {
          title: i18n.t('routes.authentication'),
        },
      },
    ],
  },

  {
    path: '/progress',
    component: () => import('src/modules/global/layouts/MainLayoutWithoutMobileNavbar.vue'),
    children: [
      {
        path: '',
        component: () => import('src/modules/user/activity-score/ProgressPage.vue'),
        name: 'Progress page',
        meta: {
          title: i18n.t('routes.progress'),
          requiresAuth: true,
        },
      },
    ],
  },
];

// Always leave this as last one
routes.push({
  path: '*',
  name: '404',
  component: () => import('src/modules/global/Error404.vue'),
});

export default routes;
